import { InputComponentEmits, useInputComponent } from "./useInputComponent.mjs";
import { computed } from "vue";
import { deepEqual } from "@spoferan/spoferan-ts-core";
export const ToggleInputComponentEmits = [
  ...InputComponentEmits,
  "change"
  // Triggered when the value was manually changed due to user interaction, e.g., a click on the toggle
];
export function useToggleInputComponent(inputElement, props, emit = () => {
}, options = {}) {
  const trueValue = props.trueValue ?? true;
  const falseValue = props.falseValue ?? false;
  const { submitValue, sizeableString, isRequired, hasError, isEmpty, errorMessage, clearValue } = useInputComponent(props, emit, {
    ...options,
    initSubmitValue: (props2) => {
      return Array.isArray(props2.modelValue) ? props2.modelValue : props2.modelValue === trueValue || trueValue === !!props2.modelValue ? trueValue : falseValue;
    }
  });
  const isActive = computed(() => {
    return Array.isArray(submitValue.value) ? submitValue.value.some((submitValueItem) => deepEqual(submitValueItem, trueValue)) : deepEqual(submitValue.value, trueValue);
  });
  function toggle() {
    if (inputElement.value) {
      inputElement.value.click();
    }
  }
  return {
    submitValue,
    isActive,
    isRequired,
    toggle,
    hasError,
    errorMessage,
    sizeableString,
    isEmpty,
    clearValue
  };
}
